import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Imported from JS (not index.css) so Vite resolves and emits the woff2 files.
import '@fontsource-variable/inter'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
